import React, { createContext, useContext, useEffect, useState } from "react";
import { apiAdmin } from "../lib/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ala_token");
    if (!token) { setLoading(false); return; }
    apiAdmin.get("/auth/me")
      .then((res) => {
        if (res.data.role === "admin") setUser(res.data);
        else { localStorage.removeItem("ala_token"); setUser(null); }
      })
      .catch(() => { localStorage.removeItem("ala_token"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await apiAdmin.post("/auth/login", { username, password });
    localStorage.setItem("ala_token", res.data.token);
    setUser({ username: res.data.username, role: "admin" });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("ala_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
